// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3GbAq","legacyBtn":"MutateMid_legacyBtn__WbC6H"};